import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './http.service';

@Injectable()
export class StripeService {

  private _url = '/api/Stripe';

  constructor(private httpService: HttpService) { }

  saveStripeUserId(code: string, clubID: number | string, clubProgramTypeID: number | string) {
    return this.httpService.get(`${this._url}/save-stripe-user-id/${clubID}/${clubProgramTypeID}`, { params: { code } });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/stripe.service.ts